import { TOW } from "../app-consts/appConstants";
import { RootState } from "../reducers";

export const getServiceInfo = (state: RootState) => state.serviceInfo;
export const getServiceType = (state: RootState) => state.serviceInfo.id;
export const getIsServiceTow = (state: RootState) => state.serviceInfo?.serviceType === TOW;